import React, { useState } from "react";
import { arrayOf, func, string, bool } from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";

import ComparisonChartContent from "./ComparisonChartContent";
import analytics from "shared/analytics";
import { blurFocusedPopover } from "../../utils/focus";

const ComparisonChartModal = ({ rowIds, modalOpen, onClose }) => {
  const [selectedChartOptions, setValues] = useState({
    perspective: "health_system", // health_system, societal -- Same order as GridFilter
    measure: "qaly", // evlyg, qaly -- Same order as GridFilter
  });

  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setValues((oldValues) => ({
      ...oldValues,
      [name]: value,
    }));
    analytics.trackChart("change-option", { [name]: value, rowIds });
  };

  const { perspective, measure } = selectedChartOptions;
  const comparisonKeys = [
    `${perspective}_vbpb_100k_per_${measure}`,
    `${perspective}_vbpb_150k_per_${measure}`,
  ];

  const chartHeight = 500;

  const formElement = (
    <Box sx={{ alignItems: "center", display: "flex", mb: 2 }}>
      <FormControl sx={{ marginRight: 2, minWidth: 120 }}>
        <InputLabel htmlFor="select-perspective">Perspective</InputLabel>
        <Select
          value={selectedChartOptions.perspective}
          onChange={handleOptionChange}
          onClose={blurFocusedPopover}
          slotProps={{
            input: {
              name: "perspective",
              id: "select-perspective",
            },
          }}
        >
          <MenuItem value="health_system">Health System</MenuItem>
          <MenuItem value="societal">Societal</MenuItem>
        </Select>
      </FormControl>
      <FormControl sx={{ marginRight: 2, minWidth: 120 }}>
        <InputLabel htmlFor="select-measure">Measure</InputLabel>
        <Select
          value={selectedChartOptions.measure}
          onChange={handleOptionChange}
          onClose={blurFocusedPopover}
          slotProps={{
            input: {
              name: "measure",
              id: "select-measure",
            },
          }}
        >
          <MenuItem value="evlyg">per evLYG</MenuItem>
          <MenuItem value="qaly">per QALY</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );

  return (
    <Dialog id="comparison-chart-modal" fullWidth maxWidth="lg" open={modalOpen} onClose={onClose}>
      <DialogActions
        sx={{
          padding: 3,
          paddingBottom: 0,
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box>
          <DialogTitle sx={{ margin: 0, marginBottom: 2, padding: 0 }}>
            Compare My Price to ICER Prices
          </DialogTitle>
          {formElement}
        </Box>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
      <DialogContent
        sx={(theme) => ({
          padding: theme.spacing(2),
          paddingTop: 0,
          paddingBottom: theme.spacing(4),
          margin: 0,
        })}
      >
        <Paper sx={{ padding: 0 }} elevation={0}>
          <ComparisonChartContent
            comparisonKeys={comparisonKeys}
            rowIds={rowIds}
            height={chartHeight}
            selectedChartOptions={selectedChartOptions}
          />
        </Paper>
      </DialogContent>
    </Dialog>
  );
};

ComparisonChartModal.defaultProps = {};

ComparisonChartModal.propTypes = {
  // match: matchType.isRequired,
  rowIds: arrayOf(string).isRequired,
  modalOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default ComparisonChartModal;
